export default ({...props}) => {
  return `
  .delivery-actions{
   & > *{
     width:50%;
     & > *{
       width:100%;
     }
   }
  }

  `
}
